module.exports = __webpack_public_path__ + "static/media/YB5F15_1.f198b1b7.jpg";